import classNames from 'classnames';
import React, { useEffect, useState } from 'react'
import { Button } from 'antd';

function Question({question, formatMessage, answersUser, changeAnswer = {}, activeQuestion}) {
  console.log("🚀 ~ file: Question.jsx:4 ~ Question ~ question:", question)
  const [answer, setAnswer] = useState('')
  
  useEffect(() => {
    if(activeQuestion){
      setAnswer(answersUser[activeQuestion] ? answersUser[activeQuestion].answer : '')
    }
  }, [activeQuestion])

  if(!question){
    return null;
  }

  const isAnswer = answersUser[question.id] ? answersUser[question.id].isAnswer : false;

  const getArrayAnswers = () => {
    return Object.keys(question.answer)
    .filter(key => key.indexOf('answer_') > -1 && !!question.answer[key])
    .map(key => ({
      value: question.answer[key], 
      active: question.answer.correct_answer == key
    }))
  }

  const arrayChar = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  const answers = question && question.answer && getArrayAnswers() || [];

  // const answer = answers[question.id]?.answer || '';

  return (
    <div className='QuestionView'>
      <div className='question' dangerouslySetInnerHTML={{ __html: question.question }}></div>
      <div className='answer'>
        {answers.map((item, index) => 
          <label className={classNames('item', {
            true: isAnswer && item.active,
            false: isAnswer && !item.active && answer == 'answer_' + (index + 1),
          })} key={'answer_' + index}>
              <input type="radio" disabled={isAnswer} value={'answer_' + (index + 1)} name="answer" checked={answer == 'answer_' + (index + 1)} onChange={(e) => {
                // this.setState({answer: e.target.value})
                setAnswer(e.target.value)
              }} />
              <div className='var'>{arrayChar[index]}</div>
              <div className='text'>{item.value}</div>
          </label>
        )}
      </div>
      {!isAnswer && <div className='actions'>
        {/* <button disabled={!answer}>{formatMessage('sendAnswerBtn')}</button> */}
        <Button type="primary" disabled={!answer} onClick={() => {
          // this.setState({isAnswer: true})
          changeAnswer({...answersUser, [question.id]: {
            isAnswer: true, answer,
            isCorrect: question.answer.correct_answer == answer
          }})
          console.log("🚀 ~ file: Question.jsx:55 ~ Question ~ question.answer.correct_answer:", question.answer.correct_answer, answer)

        }}>{formatMessage('sendAnswerBtn')}</Button>
      </div>}
      {isAnswer && <div className='description' dangerouslySetInnerHTML={{ __html: question.description }}></div>}
    </div>
  )
}


export default Question


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionView/components/Question/Question.jsx